// @flow

import type { ServiceSettingsState } from "./types";

export const initialState: ServiceSettingsState = {
  requestsInProgress: 0,
  settings: {
    active: null,
    draft: null,
    changeset: null,
  },
  edits: null,
  schema: null,
  modals: {
    modalStep: 1,
    showEditModal: false,
    showSubmitModal: false,
  },
};

export default initialState;
